module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAACXBIWXMAACxLAAAsSwGlPZapAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAEvSURBVHgB7dvRTcMwFIXhP12AjtBNyAhsQDegGwQ2oBvABLBB0k3YgDKBuVbDO1blq0rnfNJt+2Ar7smLY8eUUnZRc+nnO2qiUfR5Wvv28hG1Y/2RYd/w5/clx7yJ6z2Q476h7UiOcYM4B4A4B4A4B4A4B4A4B4A4B4A4B4A4B4A4B4A4B4C4GsCZHD/cnnMN4IUcr53aXuM41M9106Jl3b7V+zAMS0uHUndt4BB1Rx+nGNMbZmZmZiYqYypcH7aOMe38aukUYxrj65F+LlPhuNBUcoz/HVm5vLmW4VCfBg/kaLmbWWOaagBbbk/WmLZeEUKcA0CcA0CcA0CcA0CcA0CcA0CcA0CcA0CcA0CcA4hayHFqaLuQ4/NvE6LnCfJ6BL55nT/6PJe+x+fnqN0v9KBhvDDtzKwAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/static/images/hamburger-menu-icon.png
// module id = 5NzR
// module chunks = 2 3